import React from "react";
import cn from "helpers/classnames";
import RequestQuoteForm from "./RequestQuoteForm";

const RequestQuoteSection = () => {
  return (
    <div
      className={cn(
        "tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-z-10 md:tw-flex-row"
      )}
    >
      <div
        className={cn(
          "tw-flex tw-items-center tw-max-w-[400px] tw-w-full tw-flex-col tw-gap-3 md:tw-gap-8 md:tw-max-w-[100%]",
          "md:tw-w-full md:tw-justify-center md:tw-flex-row"
        )}
      >
        <div className="tw-flex tw-flex-col tw-items-start tw-w-full md:tw-w-auto">
          <h2 className="title-4 tw-mt-0 tw-mb-1">Request a quote</h2>
          <p className="subtitle-1 tw-text-left tw-mb-0 md:tw-max-w-[250px]">
            Groups can save up to 93% on annual subscriptions.
          </p>
        </div>
        <RequestQuoteForm />
      </div>
    </div>
  );
};

export default RequestQuoteSection;
